"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const season_fragment_1 = __importDefault(require("../fragments/season.fragment"));
const mutation = (0, client_1.gql) `
  mutation publishSeason($seasonId: String!, $published: Boolean) {
    publishSeason(seasonId: $seasonId, published: $published) {
      _id
      orgId
      name
      subtitle
      description
      userAgreement
      processAs
      posterImageUrl {
        original
        medium
        small
      }
      venueId
      createdAt
      publishable
      seatingChartKey
      age
      sendQRCode
      hasOrders
      taxDeduction
      organization {
        orgName
        stripeId
      }
      venue {
        _id
        name
        tax
        address {
          state
          city
          timezone
        }
        imageUrls
      }
      published
      salesBeginImmediately
      isGuestTicketSale
      ...SeasonSchedule
      ...Location
      ...Performances
      ...TicketTypes
      ...TicketHolds
      ...SeasonUpgrades
      ...SeasonPromotions
      ...SeasonCustomFields
      ...TicketExchange
      ...Fees
      ...Artists
      ...WebFlowEntity
      ...Analytics
      ...SeasonEvents
    }
  }

  ${season_fragment_1.default.fragments.schedule}
  ${season_fragment_1.default.fragments.location}
  ${season_fragment_1.default.fragments.performances}
  ${season_fragment_1.default.fragments.ticketTypes}
  ${season_fragment_1.default.fragments.holds}
  ${season_fragment_1.default.fragments.upgrades}
  ${season_fragment_1.default.fragments.promotions}
  ${season_fragment_1.default.fragments.customFields}
  ${season_fragment_1.default.fragments.exchange}
  ${season_fragment_1.default.fragments.fees}
  ${season_fragment_1.default.fragments.artists}
  ${season_fragment_1.default.fragments.webFlowEntity}
  ${season_fragment_1.default.fragments.analytics}
  ${season_fragment_1.default.fragments.Events}
`;
exports.default = mutation;
//# sourceMappingURL=publishSeason.mutation.js.map